import React from 'react';
import { Select } from "antd";

interface CGMFilterProps {
  selectedValues: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
  label?: string;
}

const CGMFilter: React.FC<CGMFilterProps> = ({
  selectedValues,
  onChange,
  placeholder = "Select options...",
  disabled = false,
}) => {
const options = [
  { label: "All Patients", value: "" },
  { label: "CGM Connected", value: "CONNECTED" },
  { label: "CGM Disconnected", value: "DISCONNECTED" },
  { label: "CGM Expired", value: "EXPIRED" },
];
  return (
    <Select
      value={selectedValues}
      style={{ width: "100%" }}
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
      className="search-input"
      size="large"
      key={''}
    >
      {options.map((item) => (
        <Select.Option value={item.value}>{item.label}</Select.Option>
      ))}
    </Select>
  );};

export default CGMFilter;